/// <reference types="microsoft-ajax" />
/// <reference types="sharepoint" />
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SharepointService {
    public spCamlQueryPaging: SP.CamlQuery ;

    //#region Constructor
    constructor() {
        
     }

    //#endregion

    //#region Methods
    getById(webUrl: string, listName: string, id: number): Subject<SP.ListItem> {

        let subject = new Subject<SP.ListItem>();
        SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {
            let context: SP.ClientContext = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + "/" + webUrl);
            let list: SP.List = context.get_web().get_lists().getByTitle(listName);
            let item: SP.ListItem = list.getItemById(id);
            context.load(item);
            context.executeQueryAsync(
                (sender, args) => {

                    subject.next(item);
                    subject.complete();
                }, (sender, args) => {
                    subject.error(args);
                    subject.complete();

                }
            );
        });
        return subject;
    }

    getByIdAttachment(webUrl: string, listName: string, id: number): Subject<SP.ListItem> {

        let subject = new Subject<SP.ListItem>();
        SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {
            let context: SP.ClientContext = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + "/" + webUrl);
            let list: SP.List = context.get_web().get_lists().getByTitle(listName);
            let item: SP.ListItem = list.getItemById(id);
            var attachmentFiles = item.get_attachmentFiles()
            context.load(item);
            context.load(attachmentFiles);
            context.executeQueryAsync(
                (sender, args) => {
                    subject.next(item);
                    subject.complete();
                }, (sender, args) => {
                    subject.error(args);
                    subject.complete();

                }
            );
        });
        return subject;
    }

    getItemsByFilter(webUrl: string, listName: string, camlQuery: string, folderPath?: string, includes? : string): Subject<SP.ListItemCollection> {

        let subject = new Subject<SP.ListItemCollection>();
        SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {
            let context: SP.ClientContext = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + "/" + webUrl);
            let list: SP.List = context.get_web().get_lists().getByTitle(listName);
            let spCamlQuery: SP.CamlQuery = new SP.CamlQuery();
            if (folderPath != null) {
                spCamlQuery.set_folderServerRelativeUrl(folderPath);
            }
            spCamlQuery.set_viewXml(camlQuery);
            let items = list.getItems((spCamlQuery));
            if(includes)
                context.load(items,includes);
            else
                context.load(items);
            context.executeQueryAsync(
                (sender, args) => {
                    subject.next(items);
                    subject.complete();
                }, (sender, args) => {
                    subject.error(args.get_message());
                }
            );
        });
        return subject;
    }

    getItemsByFilterPaging(webUrl: string, listName: string,camlQuery: string, folderPath?: string, includes? : string): Subject<any> {

        let subject = new Subject<any>();
        SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {
            let context: SP.ClientContext = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + "/" + webUrl);
            let list: SP.List = context.get_web().get_lists().getByTitle(listName);
            if(!this.spCamlQueryPaging){
                this.spCamlQueryPaging = new SP.CamlQuery();
            }
            if (folderPath != null) {
                this.spCamlQueryPaging.set_folderServerRelativeUrl(folderPath);
            }
            this.spCamlQueryPaging.set_viewXml(camlQuery);
            let data : any = {} ;
            data.items  = list.getItems(this.spCamlQueryPaging);
            if(includes)
                context.load(data.items,includes, 'ListItemCollectionPosition');
            else
                context.load(data.items);
            context.executeQueryAsync(
                (sender, args) => {
                    data.hasNext = data.items.get_listItemCollectionPosition() != null; 
                    subject.next(data);
                    subject.complete();
                    this.spCamlQueryPaging.set_listItemCollectionPosition (data.items.get_listItemCollectionPosition());
                }, (sender, args) => {
                    subject.error(args.get_message());
                }
            );
        });
        return subject;
    }

    getCurrentUserLoginName(webUrl: string): Subject<any> {
        let subject = new Subject<any>();
        SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {
            let context: SP.ClientContext = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + "/" + webUrl);
            let currentUser: any = context.get_web().get_currentUser();
            context.load(currentUser);
            context.executeQueryAsync(
                (sender, args) => {
                    subject.next(currentUser);
                    subject.complete();
                }, (sender, args) => {
                    subject.error(args.get_message());
                }
            );
        });
        return subject;
    }

    deleteListItems(webUrl: string, listName: string, camlQuery: string): Subject<any> {

        let subject = new Subject<any>();
        SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {
            let context: SP.ClientContext = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + "/" + webUrl);
            let list: SP.List = context.get_web().get_lists().getByTitle(listName);
            let spCamlQuery: SP.CamlQuery = new SP.CamlQuery();
            spCamlQuery.set_viewXml(camlQuery);
            let items = list.getItems(spCamlQuery);
            context.load(items);
            context.executeQueryAsync(
                (sender, args) => {
                    var itemCount = items.get_count();
                    //For each list item in the collection, mark it to be deleted
                    for (var i = itemCount - 1; i >= 0; i--) {
                        var oListItem = items.itemAt(i);
                        oListItem.deleteObject();
                    };
                    context.executeQueryAsync(
                        (sender, args) => {
                            subject.next(true);
                            subject.complete();
                        }, (sender, args) => {
                            subject.error(args.get_message());
                        }
                    );
                }, (sender, args) => {
                    subject.error(args.get_message());
                }

            );
        });
        return subject;
    }

    insertListItems(webUrl: string, listName: string, items: Array<any>[]): Subject<any> {
        let subject = new Subject<any>();
        SP.SOD.executeFunc('sp.js', 'SP.ClientContext', () => {
            let context: SP.ClientContext = new SP.ClientContext(_spPageContextInfo.siteAbsoluteUrl + "/" + webUrl);
            let list: SP.List = context.get_web().get_lists().getByTitle(listName);
            for (let index = 0; index < items.length; index++) {
                var itemCreateInfo = new SP.ListItemCreationInformation();
                var oListItem = list.addItem(itemCreateInfo);
                Object.getOwnPropertyNames(items[index]).forEach(
                    function (property, idx, array) {
                      oListItem.set_item(property, items[index][property]);;
                    }
                );
                oListItem.update();
            }

            context.executeQueryAsync(
                (sender, args) => {
                    subject.next(true);
                    subject.complete();
                }, (sender, args) => {
                    subject.error(args.get_message());
                }
            );
        });
        return subject;
    }
    //#endregion

}